export const linkedIn = "https://www.linkedin.com/in/faizanalam123/";

export const Resume = "https://drive.google.com/file/d/1_193vF2-Vi6ybXyy5Rkgugnrb9prr__S/view?usp=sharing";

export const navLinks = [
    {
        id: 101,
        title: "Home",
        link: "home",
    },
    {
        id: 102, 
        title: "About",
        link: "about",
    },
    {
        id: 103,
        title: "Skills",
        link: "skills",
    },
    {
        id: 104,
        title: "Projects",
        link: "projects",
    }
]